import { CellSetting } from './../../../layout/cell-setting';
import { LayoutService } from 'src/app/layout/layout.service';
import { Component, Input, OnInit, Output } from '@angular/core';
import { ParameterValueChangedArgs, Widget } from '../dashboard';
import { DashboardService } from '../dashboard.service';
import { EventEmitter } from '@angular/core';
import { FilterFieldValue, WidgetFieldValue } from '../../subscription/classes';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.less'],
})
export class WidgetComponent implements OnInit {
  @Input() widgetId = 0;
  @Input() dashboardId = 0;
  @Input() dashboardParamNames: string[] = [];
  @Output() clicked = new EventEmitter();
  @Input() withBorders = true;
  @Input() width = 0;

  locatlCurrency = g.companyConfiguration.LocalCurrency;

  drawerVisible = false;

  // tableIsLoading = false;
  dataTable: { name: string; dataset: any[] };
  cellSettings: CellSetting[] = [];

  dataArray: any[];
  data = [];
  datas = [];
  valueColumns: { [key: string]: boolean } = {};
  valueColumnsKeys: string[] = [];

  widgetStructure: Widget;
  isLoading = true;
  is2d = false;

  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5',
      '#FFB547', '#6E3D87'
    ],
  };
  cardColor = '#232837';


  view = {
    nzXs: 24,
    nzSm: 24,
    nzMd: 12,
    nzLg: 8,
    nzXl: 6,
    nzXXl: 6,
  };
  squareData: any;
  loadingDrawer = false;
  isEmpty = false;
  dataResponse: any;

  constructor(
    private dashboardService: DashboardService,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    this.dashboardService.parameterValueChanged.subscribe(
      (e: ParameterValueChangedArgs) => {
        if (e.dashboardId === this.dashboardId) {
          const filtersToApply: WidgetFieldValue[] = [];
          const params: { [key: string]: any } = {};
          e.dashboardParamNames.forEach((element) => {
            filtersToApply.push({
              FieldName: element,
              Value: e.dashboardParams[element],
            });
            params[element] =
              e.dashboardParams[element] == null
                ? ''
                : e.dashboardParams[element];
          });

          this.dashboardService
            .getWidgetStructure(this.widgetId)
            .subscribe((d: Widget) => {
              this.widgetStructure = d;
              if (this.widgetStructure.ChartType !== 12) {
                this.withBorders = true;
              }

              this.widgetStructure.Show = true;
              if (this.widgetStructure.ValueColumn != null) {
                this.valueColumnsKeys =
                  this.widgetStructure.ValueColumn.split(';');

                for (const valueColumn of this.valueColumnsKeys) {
                  if (valueColumn === 'Inactive') {
                    this.valueColumns[valueColumn] = false;
                  } else {
                    this.valueColumns[valueColumn] = true;
                  }
                }
              }

              if (this.widgetStructure.RenderAsSquare) {
                this.isLoading = true;

                this.layoutService
                  .executeQuery(
                    this.widgetStructure.SquareSQLStatementId,
                    params
                  )
                  .subscribe((data) => {
                    this.isLoading = false;
                    this.squareData = data[0];
                    if (
                      this.squareData.Value == 0 ||
                      this.squareData.Value == null
                    ) {
                      //this.widgetStructure.Show = false;
                    } else {
                      this.widgetStructure.Show = true;
                    }
                  });
              }

              this.dashboardService
                .getWidgetData(this.widgetId, filtersToApply, false)
                .then((data: any) => {
                  this.dataResponse = data;
                  this.dataArray = [...(data?.rowsArray ?? [])];
                  this.setData(params);
                });
            });
        }
      }
    );

    this.dashboardService
      .getWidgetStructure(this.widgetId)
      .subscribe((d: Widget) => {
        if (d == null) {
          this.isEmpty = true;
          this.isLoading = false;
          return;
        }

        this.widgetStructure = d;
        if (this.widgetStructure.ChartType !== 12) {
          this.withBorders = true;
        }

        this.widgetStructure.Show = true;
        const {
          filtersToApply,
          params,
        }: {
          filtersToApply: WidgetFieldValue[];
          params: { [key: string]: any };
        } = this.getDashboardAndParams();

        if (this.widgetStructure.RenderAsSquare) {
          this.isLoading = true;

          /*.executeQuery(queryId, {
            WhsCode: this.dataset[this.row].WhsCode,
            ItemCode: this.dataset[this.row].ItemCode,
            UoMEntry: this.dataset[this.row].UomEntry,
            BinAbs : ''
          })*/

          this.layoutService
            .executeQuery(this.widgetStructure.SquareSQLStatementId, params)
            .subscribe((data) => {
              this.isLoading = false;
              this.squareData = data[0];
            });
        } else {
          this.dashboardService
            .getWidgetData(this.widgetId, filtersToApply, false)
            .then((data: any) => {
              this.dataResponse = data;
              this.dataArray = [...(data?.rowsArray ?? [])];
              if (this.dataArray != null) {
                this.setData(params);
              }
              this.isLoading = false;
            });
        }
      });
  }

  private getDashboardAndParams() {
    if (this.widgetStructure.ValueColumn != null) {
      this.valueColumnsKeys = this.widgetStructure.ValueColumn.split(';');

      for (const valueColumn of this.valueColumnsKeys) {
        if (valueColumn === 'Inactive') {
          this.valueColumns[valueColumn] = false;
        } else {
          this.valueColumns[valueColumn] = true;
        }
      }
    }

    const filtersToApply: WidgetFieldValue[] = [];
    const params: { [key: string]: any } = {};
    this.dashboardParamNames.forEach((element) => {
      filtersToApply.push({
        FieldName: element,
        Value: '',
      });
      params[element] = '';
    });
    return { filtersToApply, params };
  }

  openWidgetDrawer() {
    this.drawerVisible = true;
    const {
      filtersToApply,
      params,
    }: {
      filtersToApply: WidgetFieldValue[];
      params: { [key: string]: any };
    } = this.getDashboardAndParams();

    this.loadingDrawer = true;
    this.dashboardService
      .getWidgetData(this.widgetId, filtersToApply, false)
      .then((data: any) => {
        this.dataResponse = data;
        this.dataArray = [...(data?.rowsArray ?? [])];
        this.setData(params);
      });
  }

  somethingClicked(event) {
    this.clicked.emit(event);
  }

  setData(params: { [key: string]: any } = {}) {
    // debugger;
    if (this.widgetStructure.ValueColumn == null) {
      if (this.widgetStructure.ChartType === 9) {
        this.dataTable = {
          name: '',
          dataset: [],
        };
        this.dataTable.name = this.widgetStructure.Title;
        const filterFieldValue: FilterFieldValue[] = [];
        Object.keys(params).forEach((param) => {
          filterFieldValue.push({
            FieldName: param,
            Value: [params[param]],
          });
        });

        this.layoutService
          .getSectionTableData(
            null,
            this.widgetStructure.SQLStatementId,
            '',
            0,
            this.widgetId,
            filterFieldValue,
            'widget'
          )
          .subscribe((d: any) => {
            this.dataTable.dataset = d.table.rowsArray;
            this.widgetStructure.ColumnSettingsParsed = d.columns;
            this.cellSettings = [];
            this.isLoading = false;
            this.loadingDrawer = false;
          });
      }
    } else {
      this.data = [];
      this.datas = [];
      const valueColumns = this.widgetStructure.ValueColumn.split(';');
      if (valueColumns.length === 1 || valueColumns.length === 0) {
        this.is2d = false;
        this.dataArray.forEach((row) => {
          this.data.push({
            name:
              row[this.widgetStructure.LabelColumn] === null
                ? ''
                : this.layoutService.translate(
                    row[this.widgetStructure.LabelColumn]?.toString()
                  ),
            value:
              row[this.widgetStructure.ValueColumn] === null
                ? 0
                : row[this.widgetStructure.ValueColumn],
            extra: {
              id: row.Id,
              code: row[this.widgetStructure.LabelColumn],
            },
          });
        });
      } else {
        this.is2d = true;

        if (this.widgetStructure.ChartType === 5) {
          let i = 0;
          this.dataArray.forEach((row) => {
            for (const valueColumn of this.valueColumnsKeys) {
              if (!this.valueColumns[valueColumn]) {
                continue;
              }

              if (this.datas[i] === undefined) {
                this.datas.push({
                  label: row[this.widgetStructure.LabelColumn],
                  data: [],
                });
              }

              this.datas[i].data.push({
                name: valueColumn,
                value: row[valueColumn] === null ? 0 : row[valueColumn],
                extra: {
                  code: valueColumn,
                },
              });
            }
            i++;
          });
        }
        if (this.widgetStructure.ChartType === 8) {
          this.dataArray.forEach((row) => {
            valueColumns.forEach((valueColumn) => {
              this.data.push({
                name: valueColumn,
                value: row[valueColumn] === null ? 0 : row[valueColumn],
                extra: {
                  code: valueColumn,
                },
              });
            });
          });
        } else {
          this.dataArray.forEach((row) => {
            const value = {
              name:
                row[this.widgetStructure.LabelColumn] === null
                  ? ''
                  : row[this.widgetStructure.LabelColumn]?.toString(),
              series: [],
            };

            valueColumns.forEach((valueColumn) => {
              value.series.push({
                name: valueColumn,
                value: row[valueColumn] === null ? 0 : row[valueColumn],
                extra: {
                  code: valueColumn,
                },
              });
            });

            this.data.push(value);
          });
        }
      }

      this.isLoading = false;
      this.loadingDrawer = false;
    }
  }

  exportToExcel() {
    const filters = this.getDashboardAndParams();

    this.dashboardService
    .getWidgetData(this.widgetId, filters.filtersToApply, true)
    .then((data: any) => {
      this.downloadFile(data.FileContent, 'excel');
    });
  }

  downloadFile(data: string, type: string) {
    let mimeType = '';
    let extension = '';
    if (type === 'excel') {
      mimeType = 'application/vnd.ms-excel';
      extension = 'xlsx';
    } else if (type === 'csv') {
      mimeType = 'text/csv';
      extension = 'csv';
    } else if (type === 'pdf') {
      mimeType = 'application/pdf';
      extension = 'pdf';
    }

    let dataToDownload: Blob;
    if (type === 'csv') {
      const blob = new Blob([data], {
        type: mimeType,
      });
      dataToDownload = blob;
    } else {
      const blob = new Blob([this.base64ToArray(data)], {
        type: mimeType,
      });
      dataToDownload = blob;
    }

    const url = window.URL.createObjectURL(dataToDownload);
    const anchor = document.createElement('a');
    anchor.download = `${this.widgetStructure.Title}.${extension}`;
    anchor.href = url;
    anchor.click();
    anchor.remove();
  }

  base64ToArray(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
  }

  // saveExcelFile(buffer: any, fileName: string): void {
  //     const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //     saveAs(data, fileName + '_export_' + new Date().getTime() + '.xlsx');
  // }
}
